import { apiClient } from './client';
import type { ApiResponse } from './client';

export interface LoginInput {
  email: string;
  password: string;
}

export interface RegisterInput {
  email: string;
  username: string;
  password: string;
}

export interface AuthTokens {
  accessToken: string;
  refreshToken: string;
  expiresIn: number;
}

export interface User {
  id: string;
  email: string;
  username: string;
  role: string;
  credits: number;
  buildCount?: number;
}

export const authApi = {
  login: async (data: LoginInput): Promise<AuthTokens> => {
    const response = await apiClient.post<ApiResponse<AuthTokens>>('/auth/login', data);
    return response.data.data!;
  },

  register: async (data: RegisterInput): Promise<{ id: string; email: string; username: string }> => {
    const response = await apiClient.post<ApiResponse<{ id: string; email: string; username: string }>>('/auth/register', data);
    return response.data.data!;
  },

  logout: async (refreshToken: string): Promise<void> => {
    await apiClient.post('/auth/logout', { refreshToken });
  },

  getProfile: async (): Promise<User> => {
    const response = await apiClient.get<ApiResponse<User>>('/users/me');
    return response.data.data!;
  },

  changePassword: async (currentPassword: string, newPassword: string): Promise<void> => {
    await apiClient.post('/auth/change-password', { currentPassword, newPassword });
  },
};
